import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Add from './Add';
import List from './List';
import Summary from './Summary';
import { AddStockCheck } from './checking/Index';
import { StockCheckLocations } from './locations/Index';

function StockCheck({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/add`} component={Add} />
      <Route path={`${path}/:id/summary`} component={Summary} />
      <Route path={`${path}/:id/locations`} component={StockCheckLocations} />
    </Switch>
  );
}

export { StockCheck };
